import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TitleManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = 'TalkInvoice';
  }, [pathname]);

  return null;
};

export default TitleManager;
